import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { ThemeProvider } from './contexts/ThemeContext';
import { AuthProvider } from './contexts/AuthContext';
import { Toaster } from 'sonner';

// Components
import { Layout } from './components/Layout';
import { ErrorBoundary } from './components/ErrorBoundary';

// Páginas Públicas
import { Catalogo } from './pages/Catalogo';
import { PoliticaPrivacidade } from './pages/PoliticaPrivacidade';
import { PedidoVendedor } from './pages/PedidoVendedor';

// Páginas Admin (Privadas)
import { Login } from './pages/Login';
import { Home } from './pages/Home';
import { Dashboard } from './pages/Dashboard';
import { Products } from './pages/Products';
import { Clients } from './pages/Clients';
import { Sellers } from './pages/Sellers';
import { Carriers } from './pages/Carriers';
import { Romaneios } from './pages/Romaneios';
import PagamentosRegistrados from './pages/PagamentosRegistrados';
import { WhatsApp } from './pages/WhatsApp';
import { Configuracoes } from './pages/Configuracoes';
import { Relatorios } from './pages/Relatorios';
import { Importacao } from './pages/Importacao';
import { Notas } from './pages/Notas';
import { Profile } from './pages/Profile';
import { Analytics } from './pages/Analytics';
import { SiteEditor } from './pages/SiteEditor';

// Painéis do Vendedor (FASE 2)
import VendedorLogin from './pages/VendedorLogin';
import VendedorDashboard from './pages/VendedorDashboard';
import VendedorProfile from './pages/VendedorProfile';
import VendedorPedido from './pages/VendedorPedido';
import VendedorLayout from './components/VendedorLayout';
import TrocarSenha from './pages/TrocarSenha';

// Portal do Cliente (FASE 2-4)
// (ClienteLogin removido — agora usa /login unificado via VendedorLogin)
import ClienteDashboard from './pages/ClienteDashboard';
import ClienteRomaneioDetalhe from './pages/ClienteRomaneioDetalhe';
import ClientePedido from './pages/ClientePedido';
import ClienteProfile from './pages/ClienteProfile';
import ClienteMeusPedidos from './pages/ClienteMeusPedidos';
import ClienteLayout from './components/ClienteLayout';
import AdminAbatimentoRequests from './pages/AdminAbatimentoRequests';
import AdminComprovantesReview from './pages/AdminComprovantesReview';
import AdminUsuarios from './pages/AdminUsuarios';
import AISettings from './pages/AISettings';

function App() {
  return (
    <ErrorBoundary>
      <ThemeProvider>
        <AuthProvider>
          <BrowserRouter>
            <Routes>
              {/* Páginas Públicas */}
              <Route path="/" element={<Catalogo />} />
              <Route path="/politica-privacidade" element={<PoliticaPrivacidade />} />
              <Route path="/pedido/:token" element={<PedidoVendedor />} />
              
              {/* Login UNIFICADO (Cliente + Vendedor) */}
              <Route path="/login" element={<VendedorLogin />} />
              {/* Aliases antigos redirecionam pro novo /login */}
              <Route path="/vendedor/login" element={<Navigate to="/login" replace />} />
              {/* Portal do Vendedor — sidebar layout */}
              <Route path="/vendedor" element={<VendedorLayout />}>
                <Route path="dashboard" element={<VendedorDashboard />} />
                <Route path="pedido" element={<VendedorPedido />} />
                <Route path="vendas" element={<VendedorDashboard tabInicial="vendas" />} />
                <Route path="compras" element={<VendedorDashboard tabInicial="compras" />} />
                <Route path="profile" element={<VendedorProfile />} />
              </Route>
              {/* Rotas antigas do vendedor (fora do layout) */}
              <Route path="/vendedor/trocar-senha" element={<TrocarSenha />} />

              {/* Portal do Cliente */}
              <Route path="/cliente/login" element={<Navigate to="/login" replace />} />
              {/* Portal do Cliente — todas as rotas dentro do ClienteLayout (com sidebar) */}
              <Route path="/cliente" element={<ClienteLayout />}>
                <Route path="dashboard" element={<ClienteDashboard />} />
                <Route path="meus-pedidos" element={<ClienteMeusPedidos />} />
                <Route path="atrasados" element={<ClienteMeusPedidos onlyAtrasados />} />
                <Route path="romaneio/:id" element={<ClienteRomaneioDetalhe />} />
                <Route path="pedido" element={<ClientePedido />} />
                <Route path="profile" element={<ClienteProfile />} />
              </Route>

              {/* URL secreta de login do admin */}
              <Route path="/admindashboardsantasorayaadmin" element={<Login />} />
              
              {/* Área Administrativa - Dashboard Privado */}
              <Route path="/dashboardadminromaneio" element={<Layout />}>
                <Route index element={<Home />} />
                <Route path="dashboard" element={<Dashboard />} />
                <Route path="analytics" element={<Analytics />} />
                <Route path="site-editor" element={<SiteEditor />} />
                <Route path="products" element={<Products />} />
                <Route path="clients" element={<Clients />} />
                <Route path="vendedores" element={<Sellers />} />
                <Route path="carriers" element={<Carriers />} />
                <Route path="romaneios" element={<Romaneios />} />
                <Route path="pagamentos" element={<PagamentosRegistrados />} />
                <Route path="notas" element={<Notas />} />
                <Route path="whatsapp" element={<WhatsApp />} />
                <Route path="relatorios" element={<Relatorios />} />
                <Route path="importacao" element={<Importacao />} />
                <Route path="configuracoes" element={<Configuracoes />} />
                <Route path="perfil" element={<Profile />} />
                <Route path="abatimento-requests" element={<AdminAbatimentoRequests />} />
                <Route path="comprovantes-review" element={<AdminComprovantesReview />} />
                <Route path="usuarios" element={<AdminUsuarios />} />
                <Route path="ai-settings" element={<AISettings />} />
              </Route>
            </Routes>
            <Toaster position="top-right" richColors />
          </BrowserRouter>
        </AuthProvider>
      </ThemeProvider>
    </ErrorBoundary>
  );
}

export default App;

